import { render } from "./SendDocumentBlock.vue?vue&type=template&id=71c7d134"
import script from "./SendDocumentBlock.vue?vue&type=script&lang=js"
export * from "./SendDocumentBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__